import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, vShow as _vShow, createVNode as _createVNode, withDirectives as _withDirectives, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-1fbb5041"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "pricing-table-content" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_PricingTableSection = _resolveComponent("PricingTableSection");
    const _component_PricingTablePriceSummary = _resolveComponent("PricingTablePriceSummary");
    const _component_EditorNodeWrapper = _resolveComponent("EditorNodeWrapper");
    return (_openBlock(), _createBlock(_component_EditorNodeWrapper, {
        class: _normalizeClass(['pricing-table-container', _ctx.blockWidthClass]),
        onObserveNodeVisibility: _cache[1] || (_cache[1] = ($event) => (_ctx.$emit('observe-node-visibility', Object.assign(Object.assign({}, $event), { nodeId: _ctx.node.id }))))
    }, {
        default: _withCtx(() => [
            _createElementVNode("div", _hoisted_1, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sections, (section) => {
                    return (_openBlock(), _createBlock(_component_PricingTableSection, {
                        key: section.id,
                        "node-id": _ctx.node.id,
                        "section-id": section.id,
                        sections: _ctx.sections,
                        "currency-settings": _ctx.node.currencySettings,
                        "is-pre-calculated": _ctx.node.preCalculated,
                        "is-block-width-small": _ctx.isBlockWidthSmall,
                        "merge-values": _ctx.mergeValues,
                        fields: _ctx.fieldsWithInput || [],
                        context: _ctx.context,
                        "recipient-input": _ctx.recipientInput,
                        recipient: _ctx.recipient,
                        "allowed-to-edit-after-partially-signed": _ctx.allowedToEditAfterPartiallySigned,
                        "summary-values": _ctx.getSummaryValues(_ctx.node),
                        onUpdateInputValue: _cache[0] || (_cache[0] = ($event) => (_ctx.$emit('update-input-value', $event)))
                    }, null, 8, ["node-id", "section-id", "sections", "currency-settings", "is-pre-calculated", "is-block-width-small", "merge-values", "fields", "context", "recipient-input", "recipient", "allowed-to-edit-after-partially-signed", "summary-values"]));
                }), 128)),
                _withDirectives(_createVNode(_component_PricingTablePriceSummary, {
                    "summary-values": _ctx.getSummaryValues(_ctx.node, _ctx.fieldsWithInput),
                    "currency-settings": _ctx.node.currencySettings,
                    "is-pre-calculated": _ctx.node.preCalculated,
                    fields: _ctx.fieldsWithInput || [],
                    sections: _ctx.getSectionsWithRowsFromInputValues(_ctx.node)
                }, null, 8, ["summary-values", "currency-settings", "is-pre-calculated", "fields", "sections"]), [
                    [_vShow, _ctx.getSummaryValuesPriceEnabled(_ctx.node)]
                ])
            ])
        ]),
        _: 1
    }, 8, ["class"]));
}
